import { useState } from 'react';
import { attachmentsApi, type UploadedAttachment } from '../lib/api/attachments';

interface Props {
  open: boolean;
  onClose: () => void;
  onReady: (file: UploadedAttachment, suggestedName: string) => void;
}

function filenameAsTitle(name: string): string {
  return name.replace(/\.[^.]+$/, '').replace(/[-_]+/g, ' ').trim() || 'Hợp đồng mới';
}

/** Upload trước để tài liệu luôn được giữ lại; AI Center sẽ thay bước phân tích khi relay được cấu hình. */
export function ContractAiImportModal({ open, onClose, onReady }: Props) {
  const [file, setFile] = useState<File | null>(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  if (!open) return null;

  const continueToDraft = async () => {
    if (!file) return setError('Chọn file hợp đồng trước khi tiếp tục.');
    setUploading(true); setError(null);
    try {
      const uploaded = await attachmentsApi.upload(file);
      onReady(uploaded, filenameAsTitle(file.name));
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Không thể upload file hợp đồng.');
    } finally { setUploading(false); }
  };

  return (
    <div className="cvm-backdrop" onClick={onClose}>
      <div className="ctf2-modal" style={{ maxWidth: 620 }} onClick={(e) => e.stopPropagation()}>
        <div className="ctf2-head">
          <div className="ctf2-head-left">
            <div className="ctf2-head-icon">✦</div>
            <div><h3>AI đọc hợp đồng</h3><p>Upload tài liệu để tạo bản nháp hợp đồng có file đính kèm.</p></div>
          </div>
          <button type="button" className="ctf2-close" onClick={onClose}>×</button>
        </div>
        <div className="ctf2-body" style={{ padding: 24 }}>
          <label className="ctf2-dropzone" style={{ minHeight: 150, justifyContent: 'center' }}>
            <input type="file" accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" style={{ display: 'none' }} onChange={(e) => { setFile(e.target.files?.[0] ?? null); setError(null); }} />
            <span style={{ fontSize: 24 }}>✦</span>
            <b>{file ? file.name : 'Chọn file hợp đồng'}</b>
            <span>PDF, DOC, DOCX, JPG hoặc PNG · tối đa 10MB</span>
          </label>
          <div style={{ marginTop: 16, padding: '12px 14px', border: '1px solid #bfdbfe', borderRadius: 9, background: '#eff6ff', color: '#1e3a8a', fontSize: 13, lineHeight: 1.55 }}>
            <b>AI Center chưa được kết nối qua ERP Base.</b> File vẫn được upload an toàn và form HĐ sẽ mở với tài liệu đã gắn sẵn. Khi relay AI Center có sẵn, bước này sẽ tự trích xuất mã HĐ, đối tác, giá trị và ngày ký để điền trước.
          </div>
          {error && <div className="cvm-error" style={{ marginTop: 12 }}>{error}</div>}
        </div>
        <div className="ctf2-foot"><div /><div style={{ display: 'flex', gap: 8 }}><button type="button" className="ctf2-btn-cancel" onClick={onClose}>Hủy</button><button type="button" className="ctf2-btn-save" disabled={!file || uploading} onClick={continueToDraft}>{uploading ? 'Đang upload…' : 'Upload & tạo bản nháp'}</button></div></div>
      </div>
    </div>
  );
}
